<template>
    <div>
        <div class="card-body" v-if="actualClientAnamnesis.length > 0">
          <ul class="list-group" data-testid="client-anamnesis-list">
            <li class="list-group-item" v-for="a in actualClientAnamnesis" data-testid="client-anamnesis-entry" :data-anamnesis-type-id="a.anamnesis_type.id">
              <span style="font-weight: bold;">{{ a.anamnesis_type.shortcode }} - {{ a.anamnesis_type.name }}</span><br>
              <div v-html="a.text"></div>
            </li>
          </ul>
        </div>
    </div>
</template>

<script>
  import ClientVisitChange from '../modals/ChangeVisit.vue'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        actualClientAnamnesis: false,
        actualClientAnamnesisError: false,
        actualClientAnamnesisPending: false,
        actualClientAnamnesisDone: false
      }
    },
    mixins: [apiMixin],
    props: ['doUpdate'],
    methods: {
      //
    },
    beforeMount () {
      this.getActualClientAnamnesis(this.$route.params.clientid)
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.updateVisits()
        }
      },
      selectedStates: function () {
        this.updateVisits()
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.getActualClientAnamnesis(this.$route.params.clientid)
        }
      }
    },
    components: {
      ClientVisitChange
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Client/components/ClientAnamnesis.vue?411a0a87